export const FORMAT_YYYY_MM_DD = "YYYY-MM-DD"
export const FORMAT_YYYY_MM_DD_HHmm = "YYYY-MM-DD HH:mm"
export const FORMAT_START_DAY_YYYY_MM_DD_HHmmss = "YYYY-MM-DDT00:00:00"
export const FORMAT_END_DAY_YYYY_MM_DD_HHmmss = "YYYY-MM-DDT23:59:00"
export const MAX_END_DATE = "2099/12/31 23:59"
export const DATE_TIME_SUFFIX = "Z"

export const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    PARAMETER_ERROR: -1,
    ERROR: -9,
}

export const RESULT_SETPOINT_ERROR = -1

export const INIT_STR = "";
export const INIT_NUMBER = 0;
export const BLANK = ""

// scheduleの初期化用定数
export const DEFAULT_ACTIVE_HOUR = true;
export const DEFAULT_HOURS = new Array(24).fill(DEFAULT_ACTIVE_HOUR);
export const DEFAULT_WEEK = new Array(7).fill(DEFAULT_HOURS);

export const END_DATE_TYPE = {
    MAX_DATE: 1,
    MANUAL_DATE: 2,
}

export const BILLING_TYPE = {
    CPC: 1,
    CPM: 2,
}

export const MAX_TRACKING_POINTS_NUM = 5
export const MAX_BUDGET_LIMIT_DAILY_AMOUNT = 1000

export const CREATE_PROC = 0
export const EDIT_PROC = 1

export const ARCHIVE_VALUE_NO = 6


export const CAMPAIGN_TYPE = {
    MS: 1,
    RTM: 2,
}

export const MSG = {
    SUCCESS_POST_CAMPAIGN: "キャンペーン情報作成に成功しました。",
    SUCCESS_PUT_CAMPAIGN: "キャンペーン情報更新に成功しました。",
    ERR_TRACKER_ID: "トラッカーIDが指定されていません。",
    ERR_GET_CAMPAIGN: "キャンペーン情報取得に失敗しました。",
    ERR_GET_SET_POINTS: "測定ポイント設定のデータ取得に失敗しました。",
    ERR_POST_CAMPAIGN: "キャンペーン情報作成に失敗しました。",
    ERR_PUT_CAMPAIGN: "キャンペーン情報更新に失敗しました。",
}

export const ENABLE_SCHEDULE_TIMES = [9,10,11,12,13,14,15,16,17,18,19]
export const ENABLE_SCHEDULE_TIMES_MS = [8,9,10,11,12,13,14,15,16,17,18,19,20]
